import { useSearchParams } from 'react-router-dom';
import '../elva-work.css';
import type { Period } from '../types';
import { getReport } from '../store';
import { hoursLabel, money, EW_PRACTICE, EW_TODAY } from '../utils';

export function PrintPage() {
  const [params] = useSearchParams();
  const period = (params.get('period') ?? '2026-10') as Period;
  const report = getReport(period);
  return (
    <div className="ew" style={{ height: 'auto', minHeight: '100vh', background: '#fff' }}>
      <div className="ew-wide" style={{ maxWidth: 820, margin: '0 auto' }}>
        <div>
          <h1 className="ew-h1">ELVA’s work — {report.periodLabel}</h1>
          <p className="ew-meta">{EW_PRACTICE} · Prepared by ELVA on {EW_TODAY}, 2026</p>
        </div>
        <div className="ew-figs">
          <section className="ew-card"><div className="ew-fig-label">Staff time ELVA did</div><div className="ew-fig-val num">{report.hours} hours</div><div className="ew-meta">{report.tasks} tasks</div></section>
          <section className="ew-card"><div className="ew-fig-label">Money ELVA found</div><div className="ew-fig-val num">{money(report.moneyFound)}</div><div className="ew-meta">{money(report.moneyPaid)} paid · {money(report.moneyCollecting)} being collected</div></section>
          <section className="ew-card"><div className="ew-fig-label">Who did it</div><div className="ew-fig-val">{report.onItsOwn} on its own · {report.confirmed} confirmed</div></section>
        </div>
        <section className="ew-card">
          <h2 className="ew-h2">What ELVA did</h2>
          <table className="ew-tbl">
            <thead><tr><th>Task</th><th className="r">How many</th><th>Counted as</th><th className="r">Time</th><th className="r">Money found</th></tr></thead>
            <tbody>
              {report.rows.map((r) => (
                <tr key={r.kind}><td>{r.task}</td><td className="r num">{r.count}</td><td>{r.countedAs}</td><td className="r num">{hoursLabel(r.hours)}</td><td className="r num">{r.money ? money(r.money) : '—'}</td></tr>
              ))}
              <tr className="total"><td>Total</td><td className="r num">{report.tasks}</td><td /><td className="r num">{hoursLabel(report.rows.reduce((s, r) => s + r.hours, 0))}</td><td className="r num">{money(report.moneyFound)}</td></tr>
            </tbody>
          </table>
        </section>
        {report.appeals ? (
          <section className="ew-card">
            <h2 className="ew-h2">Appeals</h2>
            <div className="ew-figs" style={{ marginTop: 10 }}>
              {report.appeals.figures.map((f) => (
                <div key={f.label} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '10px 12px' }}>
                  <div className="ew-fig-label">{f.label}</div>
                  <div style={{ fontSize: 20, fontWeight: 700, margin: '2px 0' }}>{f.value}</div>
                  <div className="ew-meta">{f.meta}</div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 12 }}>
              {report.appeals.channels.map((c) => (
                <div key={c.label} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '8px 0', borderTop: '1px solid var(--border)' }}>
                  <span><strong>{c.label}</strong><div className="ew-meta">{c.detail}</div></span>
                  <span className="ew-meta">{c.badge}</span>
                </div>
              ))}
              <p className="ew-meta" style={{ marginTop: 8 }}>{report.appeals.channelFooter}</p>
            </div>
          </section>
        ) : null}
        <section className="ew-card">
          <h2 className="ew-h2">The money ELVA found</h2>
          {report.money.map((m) => (
            <div key={m.what} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '10px 0', borderTop: '1px solid var(--border)' }}>
              <div><div style={{ fontWeight: 600 }}>{m.what}</div><div className="ew-meta">{m.note}</div></div>
              <div className="num" style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{money(m.amount)}</div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
